import { Injectable } from '@angular/core';

@Injectable()
export class DownloaderService {

  constructor() {
  }

 public downloadFile(fileName: string, base64Content: string, fileType: string) {
    const isInternetExplorerOrEdgeNavigator = navigator.msSaveOrOpenBlob;
    if (isInternetExplorerOrEdgeNavigator) {
      this.createBlobFromIEAndEdge(fileName, base64Content, fileType);
    } else {
      const linkSource = 'data:application/' + fileType + ';base64,' + base64Content + '\n';
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }

  private createBlobFromIEAndEdge(fileName: string, base64Content: string, fileType: string) {
    const converter = atob(base64Content);
    const bytesArray = new Uint8Array(converter.length);
    Array.prototype.forEach.call(converter, (ch, i) => {
      bytesArray[i] = ch.charCodeAt(0);
    });
    const type = 'application/' + fileType;
    const blob = new Blob([bytesArray], { type});
    navigator.msSaveOrOpenBlob(blob, fileName);
  }
}
